import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "NavigatorButton SearchEnrolmentsButton"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: "SearchEnrolmentsBarWrapper",
    onMouseenter: _cache[2] || (_cache[2] = ($event: any) => (_ctx.expandSearchBar())),
    onMouseleave: _cache[3] || (_cache[3] = ($event: any) => (_ctx.hideSearchBar()))
  }, [
    (!_ctx.isRevealed)
      ? (_openBlock(), _createElementBlock("button", _hoisted_1, _cache[4] || (_cache[4] = [
          _createElementVNode("i", { class: "lnr-magnifier" }, null, -1 /* CACHED */)
        ])))
      : (_openBlock(), _createElementBlock("input", {
          key: 1,
          class: _normalizeClass([
				'SearchEnrolmentsBar',
				_ctx.isActive ? 'Active' : 'Inactive',
				_ctx.isExpanded ? 'Expanded' : 'Condensed'
			]),
          ref: "searchBar",
          type: "text",
          placeholder: "Search by name or email",
          onInput: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.updateSearchQuery && _ctx.updateSearchQuery(...args)))
        }, null, 34 /* CLASS, NEED_HYDRATION */)),
    (_ctx.isActive)
      ? (_openBlock(), _createElementBlock("span", {
          key: 2,
          class: "ClearEnrolmentsSearchButton",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.clearSearchQuery && _ctx.clearSearchQuery(...args)))
        }, _cache[5] || (_cache[5] = [
          _createElementVNode("i", { class: "lnr-cross" }, null, -1 /* CACHED */)
        ])))
      : _createCommentVNode("v-if", true)
  ], 32 /* NEED_HYDRATION */))
}